import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ee277502"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "c_cell_info"
};
const _hoisted_2 = {
  class: "cell-info-left"
};
const _hoisted_3 = {
  class: "cell-info-right"
};
const _hoisted_4 = {
  class: "cell-item cell-item1"
};
const _hoisted_5 = {
  class: "p1"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i"), /*#__PURE__*/_createTextVNode("正常")], -1));
const _hoisted_7 = {
  class: "cell-item cell-item2"
};
const _hoisted_8 = {
  class: "p2"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i"), /*#__PURE__*/_createTextVNode("告警")], -1));
const _hoisted_10 = {
  class: "cell-item cell-item3"
};
const _hoisted_11 = {
  class: "p3"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createElementVNode("i"), /*#__PURE__*/_createTextVNode("离线")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_pie = _resolveComponent("pie");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_pie, {
    chartData: _ctx.chartData
  }, null, 8, ["chartData"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", _hoisted_5, [_hoisted_6, _createElementVNode("b", null, _toDisplayString(_ctx.pData['正常']), 1)])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("p", _hoisted_8, [_hoisted_9, _createElementVNode("b", null, _toDisplayString(_ctx.pData['告警']), 1)])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", _hoisted_11, [_hoisted_12, _createElementVNode("b", null, _toDisplayString(_ctx.pData['离线']), 1)])])])]);
}